import { TransmissionTypeEnum } from '@insurance/api/requests'
import { Select, SelectProps } from 'antd'
import { useTranslation } from 'react-i18next'

import { formProps } from './utils'

export const VehicleTransmissionSelect = (props: SelectProps) => {
  const { t } = useTranslation()
  const { vehicleTransmissionProps } = formProps(t)

  const options = Object.values(TransmissionTypeEnum).map((value) => ({
    label: t(value),
    value
  }))

  return (
    <Select
      placeholder={vehicleTransmissionProps.label}
      options={options}
      {...props}
    />
  )
}
